export function booleanEyeRenderer(param: { value?: string | boolean }) {
  let value = param.value;

  if (typeof value === 'string') {
    value = value === 'true';
  }

  if (value === true) {
    return '<span class="fa fa-eye black"></span>';
  }

  if (value === false) {
    return '<span class="fa fa-eye lightgrey"></span>';
  }
  return '';
}
